export const getLatestReleases = '/api/v1/member/courses/latestReleases';